import React, { useState } from "react";
import "../styles/AddMatchPopup.css";
import { add_match } from "../api/serverWrapper"; // adjust path

export default function AddMatchPopup({
  onClose,
  loadData,
  cricketAsscotions,
}) {
  const [matchData, setMatchData] = useState({
    MatchId: "-1",
    Name: "",
    DeploymentSystemId: "",
  });

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(""); // error state

  const handleChange = (e) => {
    const { name, value } = e.target;
    setMatchData({ ...matchData, [name]: value });
    setError(""); // clear error when user types/selects
  };

  const renderCricketAsscotionsOptions = () => {
    return cricketAsscotions.map((assoc) => (
      <option key={assoc.DeploymentSystemId} value={assoc.DeploymentSystemId}>
        {" "}
        {assoc.DeploymentSystemName}
      </option>
    ));
  };

  const handleSave = async () => {
    // ✅ Validation before API call
    if (!matchData.Name.trim()) {
      setError("Match Name is required.");
      return;
    }
    if (!matchData.DeploymentSystemId) {
      setError("Deployment System is required.");
      return;
    }

    try {
      setLoading(true);
      const response = await add_match(matchData);
      console.log("API Response:", response);
      onClose();
      loadData(); // Refresh data in parent
    } catch (error) {
      console.error("Error saving match:", error);
      setError("Failed to save match. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="popup_overlay">
      <div className="popup_container">
        <div className="popup_header">
          <h2 className="popup_title">Add Match</h2>
          <p className="popup_hint">Enter the match details below</p>
        </div>

        <div className="popup_body">
          <div className="popup_input_container">
            <input
              type="text"
              name="Name"
              placeholder="Enter Match Name"
              className="popup_input"
              value={matchData.Name}
              onChange={handleChange}
            />
          </div>
          <div className="popup_input_container">
            <select
              name="DeploymentSystemId"
              className="popup_input"
              value={matchData.DeploymentSystemId}
              onChange={handleChange}
            >
              <option value="">Select Deployment System</option>
                {renderCricketAsscotionsOptions()}
            </select>
          </div>

          {/* ✅ Error message */}
          {error && <p className="popup_error">{error}</p>}
        </div>

        <div className="popup_footer">
          <button className="popup_btn" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button
            className="popup_btn popup_btn_primary"
            onClick={handleSave}
            disabled={loading}
          >
            {loading ? "Saving..." : "Save"}
          </button>
        </div>
      </div>
    </div>
  );
}
